import { Paperclip } from '@phosphor-icons/react';

interface JiraAttachment {
  id: string;
  filename: string;
  mimeType: string;
  content: string;
}

interface JiraAttachmentListProps {
  attachments?: JiraAttachment[];
  headingClassName?: string;
  iconSize?: number;
}

const JiraAttachmentList = ({
  attachments,
  headingClassName = 'text-xs',
  iconSize = 13,
}: JiraAttachmentListProps) => {
  if (!attachments || attachments.length === 0) return null;

  return (
    <div className="mt-3">
      <p
        className={`mb-1 flex items-center gap-1 font-semibold text-gray-700 ${headingClassName}`}
      >
        <Paperclip size={iconSize} />
        Attachments ({attachments.length})
      </p>
      <div className="flex flex-wrap gap-2">
        {attachments.map((a) => (
          <a
            key={a.id}
            href={a.content}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-1.5 rounded border border-gray-200 bg-gray-50 px-2 py-1 text-xs text-primary-700 hover:border-primary-300 hover:bg-primary-50"
          >
            <Paperclip size={11} />
            {a.filename}
          </a>
        ))}
      </div>
    </div>
  );
};

export default JiraAttachmentList;
